module.exports = __webpack_public_path__ + "img/mtn1.4bca258f.png";